import React, { useState } from 'react';
import Navbar from '../common/Navbar';
import TicketForm from '../tickets/TicketForm';
import TicketList from '../tickets/TicketList';
import './Dashboard.css';

/**
 * Employee Dashboard - Shows ticket creation form and own tickets
 */
const EmployeeDashboard = () => {
  // State to trigger ticket list refresh after new ticket creation
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  /**
   * Handle ticket creation - refresh the ticket list
   */
  const handleTicketCreated = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <div className="dashboard">
      <Navbar />
      
      <div className="dashboard-content">
        <div className="container">
          <h1 className="dashboard-title">Employee Dashboard</h1>
          <p className="dashboard-subtitle">
            Submit IT service requests and track their status
          </p>

          <div className="dashboard-grid">
            {/* Left column - Ticket Form */}
            <div className="dashboard-column">
              <TicketForm onTicketCreated={handleTicketCreated} />
            </div>

            {/* Right column - Ticket List */}
            <div className="dashboard-column">
              <TicketList 
                isAdmin={false} 
                refreshTrigger={refreshTrigger}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployeeDashboard;